import { supabase } from './supabase';

/** Bearer header for llm-api calls: the signed-in user's session token, or the
 *  public anon key when nobody is signed in. The function verifies the session
 *  server-side and applies per-user caps to it (#74). */
export async function edgeAuthHeader(): Promise<string> {
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;
  if (!supabase) return `Bearer ${anonKey}`;
  const { data } = await supabase.auth.getSession();
  return `Bearer ${data.session?.access_token ?? anonKey}`;
}
